export function getTimeZone (){
    let timezone = '';
    if(typeof Intl.DateTimeFormat().resolvedOptions().timeZone === 'string'){
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return timezone;
}
